import * as React from "react";
import { toolEmail, toolName } from "../settings";

const rePubmedLink = /(PubMed:)([0-9][0-9]*)/;
const rePubmedLinkGlobal = /(PubMed:)([0-9][0-9]*)/g;

export function pubmedLink(pubmed: string) {
    return <a href={`https://pubmed.ncbi.nlm.nih.gov/${pubmed}/`} target="_blank">{pubmed}</a>
}

// Add links to PubMed into plain text.
// This may be used to render text from UniProtKB which contains PubMed references.
export function addPubmedLinksIntoPlainText(text: string): React.ReactNode {
    const match = text.match(rePubmedLink);
    if (match !== null) {
        const idxBefore = match.index! + match[1].length;
        const idxAfter = idxBefore + match[2].length;
        return <>
            {text.slice(0, idxBefore)}
            {pubmedLink(match[2])}
            {addPubmedLinksIntoPlainText(text.slice(idxAfter))}
        </>
    } else {
        return <>{text}</>
    }
}

// Find out ranges where PubMed references occur.
// This function helps to prevent breaking links when using show more/less functionality.
// See ShowMoreText component.
export function pubmedLinkRanges(text: string): Array<{ start: number, end: number }> {
    const matches = [...text.matchAll(rePubmedLinkGlobal)];
    return matches.map(match => ({ start: match.index!, end: match.index! + match[0].length }));
}

export function joinReactNodes(nodes: React.ReactNode[], separator: string | React.ReactNode = ', ') {
    return nodes.reduce((prev, curr) => prev !== null ? <>{prev}{separator}{curr}</> : curr, null);
}

export function emailLink(subject?: string): React.ReactNode {
    const subjectParam = subject ? `?subject=${encodeURIComponent(`${toolName}: ${subject}`)}` : '';
    return <a href={`mailto:${toolEmail}${subjectParam}`}>{toolEmail}</a>
}

export function uniprotLink(uniprot: string): React.ReactNode {
    return <a href={`https://www.uniprot.org/uniprot/${uniprot}`} target="_blank">{uniprot}</a>
}
